// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"88f4ffdf","1296":"88f4ffdf","1989":"41ee2b44"}[chunkId] + ".chunk.css";
};